<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$info"
    :title="$t('transaction_informations')"
    color="stat"
    activator-icon
    @escape="closeDialog"
  >
    <template v-slot:info>
      <v-list v-if="calc" dense>
        <v-list-item-group
          color="primary"
        >
          <v-list-item
            v-for="(value, propertyName) in calc"
            :key="propertyName"
            dense
          >
            <v-list-item-content>
              <v-list-item-title>{{ $t('fields.' + propertyName,{ currency: profile.organization.currency.name }) }}: {{ value }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </template>
  </cumulus-info-dialog>
</template>

<script>
  import { get } from 'vuex-pathify'

  export default {
    name: 'TransactionInformations',
    props: {
      transaction: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        dialogInfo: false,
      }
    },
    computed: {
      profile: get('auth/profile'),
      calc () {
        try {
          return JSON.parse(this.transaction.calc)
        } catch {
          return null
        }
      },
    },
    watch: {
      dialogInfo (val) {
        val || this.closeDialog()
      },
    },
    mounted () {
      /* UploadService.getFiles().then((response) => {
        this.fileInfos = response.data
      }) */
    },
    methods: {
      closeDialog () {
        this.dialogInfo = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)
</style>
